import hotkey from "./utils-js/hotKey"
import env from "../env"
import { runtime } from './utils-js'
import hksg from './hotKeySystemGroups'
import hkCombos from './hotKeyCombos'

function getGroupTab(combosMap) {
    return new hotkey.HotKeyGroup(
        "tab",
        "标签管理",
        [
            new hotkey.HotKey(
                "nextTab",
                combosMap.get("nextTab"),
                env.tab.next,
                "下一个标签",
            ),
            new hotkey.HotKey(
                "prevTab",
                combosMap.get("prevTab"),
                env.tab.prev,
                "上一个标签",
            ),
        ],
        true,
        true,
    )
}

function getGroupSession(combosMap) {
    return new hotkey.HotKeyGroup(
        "session",
        "会话管理",
        [
            new hotkey.HotKey(
                "showSessions",
                combosMap.get("showSessions"),
                env.showSessionList,
                "会话列表",
            ),
            new hotkey.HotKey(
                "newSession",
                combosMap.get("newSession"),
                env.ui.showSessionNew,
                "新建会话配置",
            ),
            new hotkey.HotKey(
                "dupCurSession",
                combosMap.get("dupCurSession"),
                env.tab.dupCur,
                "复制当前会话",
            ),
            new hotkey.HotKey(
                "newLocalSession",
                combosMap.get("newLocalSession"),
                env.tab.newTab,
                "新建本地会话",
                "keyup",
            ),
            new hotkey.HotKey(
                "closeCurSession",
                combosMap.get("closeCurSession"),
                env.tabDestroyCurrent,
                "关闭当前会话",
            ),
            new hotkey.HotKey(
                "toggleSessFullscreen",
                combosMap.get("toggleSessFullscreen"),
                env.tab.fullscreenCur,
                "全屏当前会话",
            ),
        ],
        true,
        true,
    )
}

function getGroupOther(combosMap) {
    return new hotkey.HotKeyGroup(
        "other",
        "其它",
        [
            new hotkey.HotKey(
                "termSearch",
                combosMap.get("termSearch"),
                env.ui.showCurTermSearch,
                "搜索",
            ),
            new hotkey.HotKey(
                "termVimMode",
                combosMap.get("termVimMode"),
                env.ui.showCurTermVimMode,
                "进入 VIM 模式",
            ),
            new hotkey.HotKey(
                "guide",
                combosMap.get("guide"),
                env.ui.showGuide,
                "使用引导",
            ),
            new hotkey.HotKey(
                "settings",
                combosMap.get("settings"),
                env.ui.showOptions,
                "设置界面",
            ),
            // new hotkey.HotKey(
            //     "showSSHTrustedHosts",
            //     combosMap.get("showSSHTrustedHosts"),
            //     env.ui.showSshKnownHosts,
            //     "SSH 信任主机",
            // ),
            // new hotkey.HotKey(
            //     "showSSHKeys",
            //     combosMap.get("showSSHKeys"),
            //     env.ui.showKeys,
            //     "SSH 密钥管理",
            // ),
        ],
        true,
        true,
    )
}

function getHotKeyGroups(combosMap) {
    let cm = combosMap ? combosMap : hkCombos.getCombosMap()
    let DefaultHotKeyGroups = [
        getGroupTab(cm),
        getGroupSession(cm),
        getGroupOther(cm),
        hksg.systemHotKeyGroupView,
        hksg.systemHotKeyGroupEdit,
    ]

    if (runtime.isElectron) DefaultHotKeyGroups.push(hksg.systemHotKeyGroupWindow)
    return DefaultHotKeyGroups
}

export default {
    getHotKeyGroups,
}
